import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { NgxSpinnerService } from "ngx-spinner"; 
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { CreateAdminComponent } from '../create-admin/create-admin.component';
import {
  HelperService
} from '../helper.service';
import {AuthGuardService} from '../auth-guard.service';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.css']
})


export class AdminUsersComponent implements OnInit {

  constructor(private userService: UserService,private SpinnerService: NgxSpinnerService, private CreateAdminComponent:CreateAdminComponent, private authGuard: AuthGuardService) {
    this.authGuard.userPermissions();

   }
  userList = [];
	userList1 = [];
	checkedPermission = [];
    userPermissions = [];
  adminFormSubmitted = false;
  edit_user_id = '';
  delete_user_id ='';
  emailError = '';
  emailUpdate = '';
  userFormTitle = 'Edit User';
  userFormBtn = 'Update';
  successMessage = HelperService.successMessage;
  ngOnInit(): void {
    this.SpinnerService.show();
    this.userListFunction();
	    this.userListFunction1();
  }
  userListFunction(){
    this.userService.getAdminUserList().subscribe(resp => {
      this.SpinnerService.hide(); 
      this.userList = resp.users;
    }) 
  }
	 userListFunction1(){
    this.userService.getSubAdminList().subscribe(resp => {
	
      this.SpinnerService.hide(); 
      this.userList1 = resp.users;
    }) 
  }
  admin_user_form = new FormGroup({
    firstname: new FormControl('', [Validators.required, Validators.minLength(3)]),
    email: new FormControl('', [Validators.required, Validators.email]),
    lastname: new FormControl('', Validators.required)
  });
	admin_user_form1 = new FormGroup({
    firstname: new FormControl('', [Validators.required, Validators.minLength(3)]),
    email: new FormControl('', [Validators.required, Validators.email]),
    lastname: new FormControl('', Validators.required),
    //password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    permissions: new FormControl(''),
  });
  
  get admin_user_f(){
    return this.admin_user_form.controls;
  }
	get admin_user_f1(){
    return this.admin_user_form1.controls;
  }
	checkPermission(value){
    //console.log(this.userPermissions);
    const current_value = this.userPermissions[value];
    //console.log(current_value);
    if (typeof current_value !== 'undefined')
    {
      return true;
    }
    return;
    //this.userPermissions
  }
  clearError(){
    this.emailError = '';
  }
  addAdmin(){
    this.edit_user_id = '';
    this.adminFormSubmitted = false;
    this.admin_user_form.reset();
    this.userFormTitle = 'Add User';
    this.userFormBtn = 'Save';
    this.CreateAdminComponent.addAdmin();
  }
	 addAdmin1(){
   
    (<HTMLFormElement>document.getElementById("admin_user_frm1")).reset();


    this.edit_user_id = '';
    this.adminFormSubmitted = false;
    this.admin_user_form1.reset();
    $('input[type=checkbox]').prop('checked', false);
    this.userFormTitle = 'Add Sub Admin';
    this.userFormBtn = 'Save';
    this.CreateAdminComponent.addAdmin();
  }

  admin_user_delete()
  {
    console.log('deletuser');
    this.SpinnerService.show();
    this.userService.deleteUser(this.delete_user_id).subscribe(
      resp => {
          this.SpinnerService.hide();
          if (resp.status == 2) { 
              this.emailError = resp.error;
              setTimeout(() => {
                this.userListFunction();
                this.emailUpdate = '';
                this.emailError = '';
                const cancelbttn = document.querySelector('.cancelbttn_delete');
                if (cancelbttn instanceof HTMLElement) {
                    cancelbttn.click();
                }
            }, 1500)
          } else {
              this.emailError = '';
              this.emailUpdate = resp.message;
              setTimeout(() => {
                    this.userListFunction();
                    this.emailUpdate = '';
                    this.emailError = '';
                    const cancelbttn = document.querySelector('.cancelbttn_delete');
                    if (cancelbttn instanceof HTMLElement) {
                        cancelbttn.click();
                    }
                }, 1500)
          }

    });
    
  }
  admin_user_submit(){

    this.SpinnerService.show();
    this.adminFormSubmitted = true;
    
    if(this.admin_user_form.invalid){
      this.SpinnerService.hide();
      return false;
    }
    const first_name  = this.admin_user_form.value.firstname;
    const last_name  = this.admin_user_form.value.lastname;
    const email  = this.admin_user_form.value.email;
    if(this.edit_user_id){
      this.userService.updateAdminUser(this.edit_user_id,email,first_name,last_name).subscribe(
        resp => {
            this.SpinnerService.hide();
            if (resp.status == 2) { 
                this.emailError = resp.validationErrors.email;
            } else {
              console.log('dasdasdasd');
                this.emailError = '';
                this.emailUpdate = this.successMessage;
                setTimeout(() => {
                      this.userListFunction();
                      this.emailUpdate = '';
                      this.emailError = '';
                      const cancelbttn = document.querySelector('.cancelbttn_email');
                      if (cancelbttn instanceof HTMLElement) {
                          cancelbttn.click();
                      }
                  }, 1500)
              // this.V_email = email;
                localStorage.setItem('nu_email', email);
            }

      });
    }
    else{
      console.log(this.admin_user_form.value);
      this.userService.createAdminUser(this.admin_user_form.value).subscribe(
        resp => {
            this.SpinnerService.hide();
            if (resp.status == 2) { 
                this.emailError = resp.validationErrors.email;
            } else {
                this.emailError = '';
                this.emailUpdate = this.successMessage;
                setTimeout(() => {
                      this.userListFunction();
                      this.emailUpdate = '';
                      this.emailError = '';
                      const cancelbttn = document.querySelector('.cancelbttn_email');
                      if (cancelbttn instanceof HTMLElement) {
                          cancelbttn.click();
                      }
                  }, 1500)
              // this.V_email = email;
                localStorage.setItem('nu_email', email);
            }

      });
    }
  }
	
	 admin_user_submit1(){
    console.log(this.checkedPermission);
    this.admin_user_form1.get('permissions').setValue(this.checkedPermission);
    this.SpinnerService.show();
    this.adminFormSubmitted = true;
    
    if(this.admin_user_form1.invalid){
      this.SpinnerService.hide();
      return false;
    }
	const first_name  = this.admin_user_form1.value.firstname;
    const last_name  = this.admin_user_form1.value.lastname;
    const email  = this.admin_user_form1.value.email;
    const password  = this.admin_user_form1.value.password;
    const permissions  = this.admin_user_form1.value.permissions;
    if(this.edit_user_id){
      this.userService.updateAdminUser(this.edit_user_id,email,first_name,last_name,password,permissions).subscribe(
        resp => {
            this.SpinnerService.hide();
            if (resp.status == 2) { 
                this.emailError = resp.validationErrors.email;
            } else {
                this.emailError = '';
                this.emailUpdate = this.successMessage;
                setTimeout(() => {
                      this.userListFunction1();
                      this.emailUpdate = '';
                      this.emailError = '';
                      const cancelbttn = document.querySelector('.cancelbttn_email1');
                      if (cancelbttn instanceof HTMLElement) {
                          cancelbttn.click();
                      }
                  }, 1500)
              // this.V_email = email;
                localStorage.setItem('nu_email', email);
            }

      });
    }
    else{
/*       console.log(this.admin_user_form.value);
      return false; */
      this.userService.createSubAdmin(this.admin_user_form1.value).subscribe(
        resp => {
            this.SpinnerService.hide();
            if (resp.status == 2) { 
                this.emailError = resp.validationErrors.email;
            } else {
                this.emailError = '';
                this.emailUpdate = this.successMessage;
                setTimeout(() => {
                      this.userListFunction1();
                      this.emailUpdate = '';
                      this.emailError = '';
                      const cancelbttn = document.querySelector('.cancelbttn_email1');
                      if (cancelbttn instanceof HTMLElement) {
                          cancelbttn.click();
                      }
                  }, 1500)
              // this.V_email = email;
                localStorage.setItem('nu_email', email);
            }

      });
    }
  }

  openModal(user_id,first_name,last_name,email){
    this.userFormTitle = 'Edit User';
    this.userFormBtn = 'Update';
    this.emailError = '';
    this.edit_user_id = user_id;
    this.admin_user_form.get('firstname').setValue(first_name);
    this.admin_user_form.get('lastname').setValue(last_name);
    this.admin_user_form.get('email').setValue(email);
  }
  deleteopenModal(user_id){
    this.delete_user_id = user_id;
  }
	
	openModal1(user_id,first_name,last_name,email,current_id=''){
    
    (<HTMLFormElement>document.getElementById("admin_user_frm1")).reset();
    this.userFormTitle = 'Edit Sub Admin';
    this.userFormBtn = 'Update';
    this.emailError = '';
    this.edit_user_id = user_id;
    console.log(current_id);
    this.userService.get_user_permissions(current_id).subscribe(
      resp => {
       // console.log(resp.permissions);
       // console.log(resp.permissions.length);
        console.log(Object.keys(resp.permissions).length);
        if(Object.keys(resp.permissions).length > 0){
          this.checkedPermission = [];
          const permissionsFormArray = this.checkedPermission;
          Object.keys(resp.permissions).forEach(function(k){
            permissionsFormArray.push({slug : k,name : resp.permissions[k]});

          });
          this.checkedPermission = permissionsFormArray;
        }
        this.userPermissions = resp.permissions;
      });
    this.admin_user_form1.get('firstname').setValue(first_name);
    this.admin_user_form1.get('lastname').setValue(last_name);
    this.admin_user_form1.get('email').setValue(email);
  }
 
	onChange(isChecked,permissions,label) {
    //console.log(label);
   // const permissionsormArray = <FormArray>this.admin_user_form.controls.permissions;
    const permissionsFormArray = this.checkedPermission;
  
    if(isChecked) {
      permissionsFormArray.push({slug : permissions,name : label});
    } else {
      const index = permissionsFormArray.findIndex(x => x.slug == permissions);
      if (index > -1) {
        permissionsFormArray.splice(index, 1);
      }

     // let p_index = permissionsFormArray.findIndex(x => x.slug == permissions);
      //permissionsFormArray.removeAt(p_index);
    } 
    this.checkedPermission = permissionsFormArray;
    console.log(this.checkedPermission);
  }
}
